/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export const getJobsProfile = async (text) => {
  try {
    const url = generateApiUrl(["jobsProfile", "getJobsProfile"], [], {
      search_txt: text,
    });
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const items = data.map((item) => {
      return {
        id: pathOr(null, ["job_occupation_data_id"], item),
        title: pathOr(null, ["title"], item),
      };
    });
    return { items };
  } catch (error) {
    throw error;
  }
};
